import { useRef } from 'react';

// A new document form's one-time save key (issue #308): sent with every Save
// of that new document, so a Save retried after a dropped connection or a
// reported failure gets back the document the earlier attempt created
// rather than a second one. One key per mounted form — opening New again
// starts a fresh document with a fresh key.
function newKey() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export default function useSaveKey() {
  const ref = useRef(null);
  if (!ref.current) ref.current = newKey();
  return ref.current;
}
